var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content_wrap",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.token ? "退出登录" : "登 录")+" ")]),_c('ProductMask',{ref:"mask",attrs:{"showBtn":false,"title":"扫码登录"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }